
import { defineComponent, PropType } from "vue";
import {
  FormConfig,
  formsConfig,
  FormTypes,
} from "@/improvementForms/formTypes";
import CameraIcon from "@/components/icons/CameraIcon.vue";
import { mapActions, mapGetters } from "vuex";
import { Optional } from "@/globalTypes";
import Loading from "@/components/Loading.vue";
import PhoneIcon from "@/components/icons/PhoneIcon.vue";
import ToolTip from "@/components/ToolTip.vue";

interface ImprovementFormData {
  content: string;
  contentError: string;
  file: Optional<File>;
  isSend: boolean;
  success: boolean;
  error: string;
  email: string;
  emailError: string;
  emailConsent: boolean;
}

export default defineComponent({
  props: {
    formType: {
      type: String as PropType<FormTypes>,
      required: true,
    },
    objectId: {
      type: String,
      required: false,
    },
  },
  data(): ImprovementFormData {
    return {
      content: "",
      contentError: "",
      file: null,
      isSend: false,
      success: false,
      error: "",
      email: "",
      emailError: "",
      emailConsent: false,
    };
  },
  mounted() {
    this.success = false;
    this.isSend = false;
    this.content = "";
    this.contentError = "";
    this.file = null;
    this.error = "";
    this.email = "";
    this.emailError = "";
    this.emailConsent = false;
  },
  methods: {
    ...mapActions("improvementForm", ["sendForm"]),
    onFileChanged(event: Event) {
      const target = event.target as HTMLInputElement;
      this.file = target.files ? target.files[0] : null;
    },
    handleSendForm() {
      this.emailError = "";
      this.contentError = "";
      this.error = "";
      if (!this.user && !this.email) {
        this.emailError = "Pole email jest obowiązkowe";
        return;
      }
      if (!this.user && !this.emailConsent) {
        this.error =
          "Musisz zaakceptować zgodę na przetwarzanie danych osobwych, bez tego nie możemy się z Tobą skontaktować.";
        return;
      }
      this.isSend = true;
      this.sendForm({
        content: this.content,
        file: this.file,
        type: this.formType,
        url: this.$route.fullPath,
        objectId: this.objectId,
        email: this.email,
        emailConsent: this.emailConsent,
      }).then(({ isSuccess, errors }) => {
        this.isSend = false;
        if (isSuccess) {
          this.success = true;
        } else {
          this.contentError = errors.content;
        }
      });
    },
  },
  computed: {
    ...mapGetters("accounts", ["user"]),
    ...mapGetters(["getPhoneNumber"]),
    formData(): FormConfig {
      return formsConfig[this.formType];
    },
  },
  components: { PhoneIcon, Loading, CameraIcon, ToolTip },
});
